import { toast } from '@systemeio/ui'
import { UnprocessableContentError } from '@systemeio/util'
import { ViolationInterface } from '@systemeio/util'
import { Dispatch, SetStateAction } from 'react'

type Parse422ErrorsType = Record<string, string>

const parse422Errors = (violations: ViolationInterface[]): Parse422ErrorsType => {
  const parsedViolations: Record<string, string> = {}

  violations.forEach(violation => {
    const { propertyPath, message } = violation

    parsedViolations[propertyPath] = parsedViolations[propertyPath]
      ? parsedViolations[propertyPath] + '\n' + message
      : message
  })

  return parsedViolations
}

export const handle422Error = <T>(e: unknown, setErrors: Dispatch<SetStateAction<T>>) => {
  if (e instanceof UnprocessableContentError) {
    const violations = e.errors.violations as ViolationInterface[]
    const parsedErrors = parse422Errors(violations)
    const { '': commonErrors, ...fieldErrors } = parsedErrors
    if (commonErrors) {
      commonErrors.split('\n').forEach(common => toast.error(common))
    }
    setErrors(prev => ({ ...prev, ...fieldErrors }))

    return fieldErrors
  }
}
